import { node, arrayOf, oneOfType } from 'prop-types';
import { components } from 'react-select';

const Option = ({ children, ...rest }) => (
  <div data-testid='option'>
    <components.Option {...rest}>{children}</components.Option>
  </div>
);

Option.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired
};

export default Option;
